module.exports = __webpack_public_path__ + "static/d16-5b00ea4ecb5371efb8401ea4b68acffb.png";